import { CLIENT_DISPATCHER_MODULE, getClientDispatcher } from '../client-dispatcher/singleton';

import { ClientReceiver } from './index';

const SERVER_STREAM_ENDED = 'SERVER_HTTP_RESPONSE_ENDED' as const;

let receiver: ClientReceiver;

export function getClientReceiver() {
	// special-case: if server, bail early and do nothing
	if (typeof window === 'undefined' || !globalThis.document) {
		return;
	}
	if (!receiver) {
		const dispatcher = getClientDispatcher();
		const sink = dispatcher.ingest.bind(dispatcher);
		receiver = new ClientReceiver(globalThis.document, sink);
		receiver.fulfilled().then(() => {
			sink({
				id: CLIENT_DISPATCHER_MODULE,
				name: '_abort',
				args: [{ reason: SERVER_STREAM_ENDED }],
			});
		});
	}
	return receiver;
}
